/**
 * Navbar
 */

import 'bootstrap/js/dist/collapse';
import $ from 'jquery';

// Custom
import 'protons';

// Module template
import './_navbar.twig';

// Import custom sass, includes Bootstrap sass
import './_navbar.scss';
import './chevron-down.svg';
import './chevron-up.svg';
import './erickson-living.svg';

export const name = 'navbar';

export function disable() {}

export function enable() {}

$(document).ready(() => {
  if ($('.navbar').length) {
    const offsetStick =
      $('.navbar').offset().top > 40 ? $('.navbar').offset().top : 40;

    $(window).scroll(() => {
      const sticky = $('.navbar');
      const scroll = $(window).scrollTop();

      if (scroll >= offsetStick) {
        sticky.addClass('fixed');
      } else {
        sticky.removeClass('fixed');
      }
    });
  }

  function toggleDropdown(e) {
    const d = $(e.target).closest('.dropdown');
    const m = $('.dropdown-menu', d);
    setTimeout(
      () => {
        const shouldOpen = e.type !== 'click' && d.is(':hover');
        if ($(window).width() > 991) {
          m.toggleClass('show', shouldOpen);
          d.toggleClass('show', shouldOpen);
          $('[data-toggle="dropdown"]', d).attr('aria-expanded', shouldOpen);
        }
      },
      e.type === 'mouseleave' ? 300 : 0
    );
  }
  if ($(window).width() > 991) {
    $('body')
      .on('mouseenter mouseleave', '.dropdown', toggleDropdown)
      .on('click', '.dropdown-menu a', toggleDropdown);
    /* not needed, prevents page reload for SO example on menu link clicked */
    $('.dropdown a').on('click tap', (e) => e.preventDefault());
  } else {
    $('.dropdown-toggle').on('click tap', (e) => e.preventDefault());
    $('.dropdown.nav-item').click(function () {
      $(this).toggleClass('show');
      $(this).find('.dropdown-menu').toggleClass('show');
    });
    $('body').on('click tap', 'a.nav-link', function () {
      const newLocation = $(this).attr('href');
      $(window).location = newLocation;
    });
  }
});

export default enable;
